import { useEffect, useState } from "react";
import { MessageSquareText, Smile, HeartHandshake, ChevronDown } from "lucide-react";
import api from "@/lib/api";
import DecodeTool from "@/components/DecodeTool";

const TABS = [
  { id: "text", label: "Text slang & trends", icon: MessageSquareText, testid: "dashboard-decode-tab-text", desc: "Words, phrases and trends your child uses." },
  { id: "emoji", label: "Emoji & meme", icon: Smile, testid: "dashboard-decode-tab-emoji", desc: "Hidden meanings in emojis, combos and memes." },
  { id: "behavior", label: "Mood & behaviour", icon: HeartHandshake, testid: "dashboard-decode-tab-behavior", desc: "Calm, non-clinical context for changes you notice." },
];

export default function Decode() {
  const [tab, setTab] = useState("text");
  const [children, setChildren] = useState([]);
  const [child, setChild] = useState(null);
  const [open, setOpen] = useState(false);
  const active = TABS.find((t) => t.id === tab);

  useEffect(() => { api.get("/children").then(({ data }) => { setChildren(data.children); if (data.children[0]) setChild(data.children[0]); }).catch(() => {}); }, []);
  const label = (c) => c ? `${c.nickname || "Child"} · ${c.age_band}` : "No specific child";

  return (
    <div className="grid lg:grid-cols-[320px_1fr] gap-8 items-start">
      <aside className="lg:sticky lg:top-24 space-y-4">
        <div>
          <h1 className="font-serif text-[28px] sm:text-[34px] font-semibold">Decode Suite</h1>
          <p style={{ color: "var(--text-muted)" }}>Three tools, one calm place. Everything you type is encrypted.</p>
        </div>
        {children.length > 0 && (
          <div className="relative">
            <button className="btn btn-outline w-full justify-between" onClick={() => setOpen(!open)} data-testid="decode-child-switcher">{label(child)} <ChevronDown size={16} /></button>
            {open && (
              <div className="absolute left-0 right-0 mt-2 dk-card p-2 z-30 anim-in">
                <button className="w-full text-left px-3 py-2 rounded-lg hover:bg-[#E5E2DC] text-sm" onClick={() => { setChild(null); setOpen(false); }}>No specific child</button>
                {children.map((c) => <button key={c.id} className="w-full text-left px-3 py-2 rounded-lg hover:bg-[#E5E2DC] text-sm" onClick={() => { setChild(c); setOpen(false); }}>{label(c)}</button>)}
              </div>
            )}
          </div>
        )}
        <div className="flex flex-col gap-2">
          {TABS.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)} data-testid={t.testid}
              className={`btn justify-start ${tab === t.id ? "btn-secondary" : "btn-outline"}`}>
              <t.icon size={16} /> {t.label}
            </button>
          ))}
        </div>
        <div className="rounded-xl p-4 text-sm" style={{ background: "var(--sage-tint)", color: "var(--text)" }}>{active.desc}</div>
      </aside>

      <div className="space-y-4">
        <DecodeTool key={tab} tool={tab} childId={child?.id} />
      </div>
    </div>
  );
}
